// Copyright (C) 2020 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {globals} from './globals';

export function isShareable() {
  return (globals.isInternalUser && isDownloadable());
}

export function isDownloadable() {
  const engine = Object.values(globals.state.engines)[0];
  if (engine && engine.source.type === 'ARRAY_BUFFER' &&
      engine.source.localOnly) {
    return false;
  }
  if (engine && engine.source.type === 'HTTP_RPC') return false;
  return true;
}